import { useEffect, useState } from 'react';
import { Outlet, useSearchParams, useLocation } from 'react-router-dom';

import { Menubar } from '@/components/Menubar';
import { Footer } from '@/components/Footer';

export default function App() {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

  // Check if we're in embed mode
  const isEmbed = searchParams.get('embed') === 'true';

  // Check if we're on an editor page (new model, examples, or viewing a model)
  const isEditorPage =
    location.pathname === '/new' ||
    location.pathname === '/examples' ||
    location.pathname.startsWith('/examples/') ||
    (location.pathname.split('/').length === 3 &&
      !['explore', 'settings', 'auth', 'blog', 'changelog'].includes(
        location.pathname.split('/')[1],
      ));

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 640);
    };
    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  // Embed mode - no chrome, just the content
  if (isEmbed) {
    return (
      <div className="h-dvh overflow-hidden bg-background">
        <Outlet />
      </div>
    );
  }

  return (
    <div className="flex h-dvh flex-col overflow-hidden bg-background">
      {isMobile ? (
        <div className="flex h-dvh w-full items-center justify-center text-muted-foreground">
          Please use a desktop browser to access this app.
        </div>
      ) : (
        <>
          {/* Show menubar on non-editor pages, editor pages have their own toolbar */}
          {!isEditorPage && <Menubar />}

          {/* Main Content */}
          <div
            className={
              isEditorPage ? 'flex-1 overflow-hidden' : 'flex-1 overflow-auto'
            }
          >
            <Outlet />
            {!isEditorPage && <Footer />}
          </div>
        </>
      )}
    </div>
  );
}
